// ======================================================================
// File Name       : ContentNotificationSearchResult
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// =======================================================================
import React from 'react';
import { Form, FormControl, Col, Button, Table, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import PaginationCustom from '../../Pagination';
import TableHead, { setSortState } from '../../TableHead';
import * as Path from '../../../constants/PathConstants';
import * as ReportConstants from '../../../constants/ScoringReportConstants';
import RenderField from '../../../utils/ReduxFormUtils';
import { MANAGEMENT_AUTHORITY_TYPE } from '../../../constants/AuthorityConstant';
import { parseDateForDetail, compareDate } from '../../../utils/index';
import { DEFAULT_DATE_FORMAT_SHORT_DETAIL, SUPER_USER_SECERN_ID } from '../../../constants/index';
import CustomButton from '../../button/CustomButton';
import CustomLink from '../../button/CustomLink';
import * as ICON from '../../../constants/IconConstants';

class ReportListResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showGetReportModal: false,
      reportDetail: {},
      buttonId: 0,
      activedButtonList: [],
    };
    // this.showDetail = this.showDetail.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.batchApproval = this.batchApproval.bind(this);
    this.getReport = this.getReport.bind(this);
    this.getReportStatus = this.getReportStatus.bind(this);
  }

  showModal() {
    this.setState({ showModal: true });
  }

  hideModal() {
    this.setState({ showModal: false, showGetReportModal: false });
  }

  showDetail(itemReportIdAuto, itemLearningHistoryReportIdAuto) {
    const { reportList } = this.props;
    for (const key in reportList) {
      const item = reportList[key];
      if (
        item.itemReportIdAuto === itemReportIdAuto &&
        item.itemLearningHistoryReportIdAuto === itemLearningHistoryReportIdAuto
      ) {
        if (item.reportStatus === ReportConstants.REPORT_STATUS_ID.SUBMITTED) {
          const { activedButtonList } = this.state;
          this.setState({ buttonId: itemLearningHistoryReportIdAuto });
          // #5056 prevent request from sending when there is another request has been executed
          this.setState({ showGetReportModal: true, reportDetail: item });
        } else {
          this.props.onShowDetail(item);
        }
        break;
      }
    }
  }

  batchApproval() {
    this.hideModal();
    this.props.onBatchApproval();
  }

  getReport(event) {
    this.hideModal();
    const disableButton = event.target.id.replace('a', '');
    this.props.handleButtonDisabled(disableButton);
    this.props.onGetReport(this.state.reportDetail);
  }
  getReportStatus(id) {
    let status = '';
    for (const key in ReportConstants.REPORT_STATUS_ID) {
      const item = ReportConstants.REPORT_STATUS_ID[key];
      if (ReportConstants.REPORT_STATUS_ID[key] == id) {
        status = ReportConstants.REPORT_STATUS_NAME[key];
      }
    }
    return status;
  }

  render() {
    const {
      onShowDetail,
      reportList,
      onExportReportList,
      onBatchApproval,
      handleSortState,
      recordNum,
      getStartEndData,
      startPosition,
      mode,
      scoringManagementAuthority,
      dataSort,
    } = this.props;
    const thead = [
      { title: '添削管理ID', sortBy: 0 },
      { title: 'レポート名', sortBy: null, width: '20%' },
      { title: 'ユーザー(提出者)', sortBy: null },
      { title: '添削者', sortBy: null },
      { title: 'ステータス', sortBy: 1},
      { title: '提出日', sortBy: 2 },
      { title: '更新日', sortBy: 9 },
      { title: '操作', sortBy: null, width: 130 },
    ];
    const theadUserNotHaveApprovePermission = [
      { title: '添削管理ID', sortBy: 0},
      { title: 'レポート名', sortBy: null , width: '20%'},
      { title: '添削者', sortBy: null},
      { title: 'ステータス', sortBy: 1},
      { title: '提出日', sortBy: 2},
      { title: '更新日', sortBy: 9},
      { title: '操作', sortBy: null, width: 130 },
    ];
    let data = thead;
    if (dataSort) {
      const sortBy = dataSort.reportHistorySortType;
      const sortState = dataSort.ascendingDescendingSort;
      data = setSortState(thead, sortBy, sortState);
    }
    let dataUserNotHaveApprovePermission = theadUserNotHaveApprovePermission;
    if (dataSort) {
      const sortBy = dataSort.reportHistorySortType;
      const sortState = dataSort.ascendingDescendingSort;
      dataUserNotHaveApprovePermission = setSortState(theadUserNotHaveApprovePermission, sortBy, sortState);
    }
    // table data
    let reportTableData = null;
    if (reportList) {
      reportTableData = reportList.map((reportData, index) => {
        const detailButtonText =
          reportData.reportStatus == ReportConstants.REPORT_STATUS_ID.SUBMITTED ? 'レポート取得' : '詳細を見る';
        const statusText = this.getReportStatus(reportData.reportStatus);
        let Submiter = '';
        let Checker = '';
        if (this.props.bySecernId[reportData.submitterUserSecernId]) {
          Submiter = this.props.bySecernId[reportData.submitterUserSecernId].userName || '';
        }
        if (reportData.checkerUserSecernId && reportData.checkerUserSecernId.toLowerCase() === SUPER_USER_SECERN_ID) {
          Checker = 'SuperUser';
        } else if (reportData.checkerUserSecernId && this.props.bySecernId[reportData.checkerUserSecernId]) {
          Checker = this.props.bySecernId[reportData.checkerUserSecernId].userName || '';
        }
        const reportSubmitDate = parseDateForDetail(reportData.reportSubmitDate, DEFAULT_DATE_FORMAT_SHORT_DETAIL);
        const reportReturnedDate = parseDateForDetail(reportData.reportReturnedDate, DEFAULT_DATE_FORMAT_SHORT_DETAIL);
        const reportUpdatedAt = parseDateForDetail(reportData.updatedAt, DEFAULT_DATE_FORMAT_SHORT_DETAIL);
        const isOverDeadline = compareDate(reportData.reportSubmitDate, reportData.reportDeadline);
        const deadlineBackground = isOverDeadline ? 'backGround_report_deadline' : '';
        const showDetailButton = detailButtonText==='詳細を見る';
        const showReportButton = detailButtonText==='レポート取得';
        return (
          <tr key={index} className={deadlineBackground} onMouseEnter={() => this.props.handleMouseEnter(index)} onMouseLeave={() => this.props.handleMouseLeave()}>
            <td>{reportData.itemLearningHistoryReportIdAuto}</td>
            <td>{reportData.reportName}</td>
            {scoringManagementAuthority &&
            scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT &&
            <td>{Submiter}</td>}
            <td>{Checker}</td>
            <td className="text-left">{statusText}</td>
            <td>{reportSubmitDate}</td>
            {/* #5854 START */}
            <td>{reportUpdatedAt}</td>
            {/* #5854 END */}
            <td className="text-center">
              {showDetailButton && (
                <CustomLink
                  className="margin-right-7 link-detail"
                  onClick={this.showDetail.bind(
                    this,
                    reportData.itemReportIdAuto,
                    reportData.itemLearningHistoryReportIdAuto,
                  )}
                  text={detailButtonText}
                />
              )}
              {showReportButton && (
                <CustomLink
                  className="margin-right-7 link-detail"
                  onClick={this.showDetail.bind(
                    this,
                    reportData.itemReportIdAuto,
                    reportData.itemLearningHistoryReportIdAuto,
                  )}
                  text={detailButtonText}
                />
              )}
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Form.Group>
          <Col sm={12} className="padding-left-right-clear margin-bottom-20">
            <Col sm={4}>
              {/* #5854 START */}
              <div style={{ paddingTop: "20px" }} >検索結果: {recordNum.toLocaleString()}件</div>
            </Col>
            <Col>
              <div className="float-end display-flex">
                <div className="form-info text-center margin-right-15">
                  {mode == ReportConstants.REPORT_LIST_MODE.APPROVAL && (
                    <CustomButton
                      className="button-form"
                      btnStyle="btn btn-primary btn-96"
                      handleClick={this.showModal}
                      text="表示中のレポートを承認"
                      iconClass="bi bi-check-lg"
                    />
                  )}
                </div>
                <CustomButton
                  btnStyle="btn-export-csv"
                  handleClick={onExportReportList.bind(this)}
                  text="一括出力"
                  iconClass="bi bi-download"
                />
              </div>
            </Col>
          </Col>
        </Form.Group>
        <Table striped hover className="margin-top-10">
          <thead>
            <TableHead
              data={scoringManagementAuthority &&
                    scoringManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT ?
                    data : dataUserNotHaveApprovePermission}
              handleSortState={handleSortState.bind(this)}
            />
          </thead>
          <tbody>{reportTableData}</tbody>
        </Table>
        <Col sm={12} className="d-flex justify-content-center">
          <div>
            <PaginationCustom
              recordNum={recordNum}
              handlePageSelect={getStartEndData.bind(this)}
              startPosition={startPosition}
            />
          </div>
        </Col>
        <Modal className="modal-container" show={this.state.showModal}>
          <Modal.Header />
          <Modal.Body>
            <div className="text-center">レポートを一括承認してよろしいですか？</div>
          </Modal.Body>
          <Modal.Footer className="text-center">
            <Button className="margin-right-10 btn-96" variant="default" onClick={this.hideModal}>
              キャンセル
            </Button>
            <Button
              className=" margin-left-10 btn-96"
              variant="primary"
              onClick={this.batchApproval}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal className="modal-container" show={this.state.showGetReportModal}>
          <Modal.Header />
          <Modal.Body>
            <div className="text-center">レポートを取得して よろしいですか？</div>
          </Modal.Body>
          <Modal.Footer className="text-center">
            <Button variant="default" className="margin-right-10 btn-96" onClick={this.hideModal}>
              キャンセル
            </Button>
            <Button id={`${this.state.buttonId}a`} className=" margin-left-10 btn-96" variant="primary" onClick={this.getReport}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userInfo } = state.user;
  const { bySecernId } = userInfo;
  return {
    ...{ bySecernId },
  };
};

export default connect(mapStateToProps)(ReportListResult);
